




















import {
    Vue, Component, Prop, Mixins, PropSync, Watch,
} from 'vue-property-decorator'

@Component
export default class HoverMask extends Vue {
    @Prop({default: ''}) pictureFile!: any          // 需要操作的图片

    @Prop({default: ''}) fileList!: any             // 图片或文件列表

    @Prop({default: false}) isShow!: boolean        // 是否点击放大预览

    @Prop({default: false}) isDownload!: boolean    // 是否可下载

    @Prop({default: true}) isDeleted!: boolean      // 是否可删除


    handleShow() {
        this.$emit('handleShow', this.pictureFile, this.fileList)
    }

    handleDelete() {
        this.$emit('handleDelete', this.pictureFile, this.fileList)
    }

    handleDownload() {
        this.$emit('handleDownload', this.pictureFile, this.fileList)
    }
}
